import { render } from "./EmailIcon.vue?vue&type=template&id=4a6ee166"
const script = {}
script.render = render

export default script